/* TODO: t() */
import React from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';
import formatDate from '../../core/support/formatDate';
import { VendorAccount } from '../../types/shared/VendorAccount';
import LoadingIndicator from '../uiold/LoadingIndicator';
import { Text } from '../uiold';
import { themeColors } from '../uiold/Constants';

type Props = {
  vendorAccounts: Map<string, VendorAccount> | null | undefined;
  selectedID: string | null | undefined;
  filterText: string;
  onItemClick: (id: string) => void;
};

function VendorAccountList(props: Props) {
  let { vendorAccounts, selectedID, filterText, onItemClick } = props;

  if (!vendorAccounts) {
    return <LoadingIndicator />;
  }

  let filteredVendorAccounts = filterVendorAccounts(vendorAccounts, filterText);
  let results = Array.from(filteredVendorAccounts, ([id, vendorAccount]) => (
    <VendorAccountListItem
      key={vendorAccount.id}
      isSelected={id === selectedID}
      vendorAccount={vendorAccount}
      onPress={onItemClick}
    />
  ));
  return <>{results}</>;
}

function VendorAccountListItem(props: {
  vendorAccount: VendorAccount;
  isSelected: boolean;
  onPress?: (userID: string) => void;
}) {
  let { vendorAccount, isSelected, onPress } = props;
  let isActive = vendorAccount.active;

  let rootStyle = [
    styles.listItem,
    isActive && styles.active,
    isSelected && styles.selected,
  ];
  return (
    <TouchableOpacity
      onPress={() => (onPress ? onPress(vendorAccount?.id) : null)}
      style={rootStyle}
    >
      <Text style={styles.name}>{vendorAccount.name}</Text>
      {vendorAccount?.email ? (
        <Text style={styles.text}>{vendorAccount.email}</Text>
      ) : null}
      <Text style={styles.text}>
        Status: {isActive ? 'Verified' : 'Pending Email Verification'}
      </Text>
      <Text style={styles.text}>
        Created: {formatDate(vendorAccount.createdAt)}
      </Text>
    </TouchableOpacity>
  );
}

function filterVendorAccounts(
  vendorAccounts: Map<string, VendorAccount>,
  filterText: string,
) {
  let searchText = filterText.toLowerCase().trim();
  if (searchText === '') {
    return vendorAccounts;
  }
  let results = new Map();
  for (let vendorAccount of vendorAccounts.values()) {
    if (vendorAccountMatches(vendorAccount, searchText)) {
      results.set(vendorAccount?.id, vendorAccount);
    }
  }
  return results;
}

function vendorAccountMatches(vendorAccount: VendorAccount, query: string) {
  const queryLower = query.toLowerCase();
  for (const key of ['name', 'email'] as const) {
    const value: string = vendorAccount[key];
    if (value.toLowerCase().includes(queryLower)) {
      return true;
    }
  }
  return false;
}

let styles = StyleSheet.create({
  listItem: {
    padding: 15,
    backgroundColor: themeColors.white,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: themeColors.lightGrey,
    borderLeftColor: '#D69E2E',
    cursor: 'pointer',
  },
  active: {
    borderLeftColor: '#38A169',
  },
  selected: {
    borderColor: themeColors.withOpacity.blue50,
    backgroundColor: themeColors.withOpacity.blue8,
  },
  name: {
    fontSize: 15,
    fontWeight: '500',
    color: '#2b4a5c',
    lineHeight: 22,
  },
  text: {
    fontSize: 13,
    color: '#577688',
    lineHeight: 22,
  },
});

export default VendorAccountList;
